import { UpdateFieldReqField, ValidEmotion } from '@/api/generated/model';

export type EditableFieldName =
  | 'topic'
  | 'intent'
  | 'user_action'
  | 'category'
  | 'risky_behavior'
  | 'model_suggestion'
  | 'custom_aggregate'
  | 'text_language'
  | 'sentiment'
  | 'emotions';

/**
 * Builds the `update-field` request field payload for a given editable axis.
 *
 * Custom taxonomy axes ("custom aggregates") use a dedicated union variant
 * discriminated by `field_name: 'custom_aggregate'` that carries the axis
 * internal name (`aggregate_name`) and the class to assign (`value`, `null`
 * clears the membership), mirroring the built-in "move-to" behaviour.
 */
export function buildUpdateFieldPayload(
  fieldName: EditableFieldName,
  newValue: string | null,
  oldValue?: string | null,
  customAggregateName?: string,
): UpdateFieldReqField {
  if (fieldName === 'emotions') {
    return {
      field_name: 'emotions',
      field_value: newValue as ValidEmotion | null,
      old_emotion: oldValue ?? null,
    };
  }

  if (fieldName === 'custom_aggregate') {
    return {
      field_name: 'custom_aggregate',
      aggregate_name: customAggregateName ?? '',
      value: newValue,
    };
  }

  return {
    field_name: fieldName,
    field_value: newValue as string | null,
  } as UpdateFieldReqField;
}
